/**
 * @param {Object} args
 * @param {Function} args.setHighlightedPickedOptions
 * @param {Function} args.onChange
 * @returns {void}
 */
export const removeAllPickedOptions = _ref => {
  let {
    setHighlightedPickedOptions,
    onChange
  } = _ref;
  setHighlightedPickedOptions([]);
  onChange({
    selected: []
  });
};